// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import makeRecipeTimeText from 'app/common/lib/util/makeRecipeTimeText';
import { roundHoursMinutes } from 'app/packages/recipe-star-components/utils';
import { Box, Text, Icon } from 'gestalt';

const CLOCK_ICON_SIZE = 16;

type Props = {
  recipe: ?Object,
  iconSize?: number,
  isInPinGrid?: boolean,
};

const PinLandingRecipeTime = ({
  recipe,
  iconSize = CLOCK_ICON_SIZE,
  isInPinGrid = false,
}: Props) => {
  if (!recipe) {
    return null;
  }

  const { prepTime, cookTime, totalTime } = recipe;
  let time = totalTime || cookTime || prepTime;
  if (cookTime && prepTime) {
    const cookhours = cookTime.h || 0;
    const cookmin = cookTime.m || 0;
    const prephours = prepTime.h || 0;
    const prepmin = prepTime.m || 0;
    time = { h: cookhours + prephours, m: cookmin + prepmin };
  }

  if (!time) {
    return null;
  }

  const timeLabel = makeRecipeTimeText(roundHoursMinutes(time));

  return (
    <Box display="flex" alignItems="center" marginTop={1}>
      <Box marginRight={1}>
        <Icon
          accessibilityLabel={i18n._('clock', 'accessible label for clock icon on recipe rich pin')}
          color="darkGray"
          icon="clock"
          size={iconSize}
        />
      </Box>
      <Text bold={!isInPinGrid} size={isInPinGrid ? 'sm' : 'md'}>
        {timeLabel}
      </Text>
    </Box>
  );
};

export default PinLandingRecipeTime;
